import React, { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from "react-i18next";
import RoutesWrapper from './RoutesWrapper'; // Handles routing
import Footer from './Components/Footer/Footer';
import { useDispatch } from 'react-redux';
import { getSettings } from './redux/Slices/users/thunk';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    document.body.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  useEffect(() => {

    dispatch(getSettings())

    const handleWheel = (e) => {
      if (e.target.type === 'number') {
        e.target.blur(); 
        e.preventDefault(); 
      }
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);


  return (
    <div className='d-flex justify-content-center flex-column overflow-hidden ' style={{minHeight:"100vh"}}>
      {/* Ensure BrowserRouter wraps RoutesWrapper */}
      <BrowserRouter>
        <Suspense fallback="loading...">
          <RoutesWrapper />
          
        </Suspense>
      </BrowserRouter>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={document.body.dir === "rtl"}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
